import { ZIndex } from "@/domains/design/constants";
import styled from "@emotion/styled";

export const HorizontalScrollStyledWrapper = styled.div`
  position: relative;
`;

export const HorizontalScrollStyledScrollable = styled.div`
  display: flex;
  justify-content: flex-start;
  flex-direction: row;
  flex-wrap: nowrap;
  align-items: center;
  overflow-x: auto;
  scrollbar-width: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

export const HorizontalScrollStyledLeftShadow = styled.div<{ $visible: boolean }>`
  user-select: none;
  pointer-events: none;
  background: linear-gradient(
    90deg,
    ${({ theme }) => theme.colors.surface.pane} 20%,
    transparent 100%
  );
  bottom: 0;
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100px;
  z-index: ${ZIndex.Shadow};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.2s ease;
`;

export const HorizontalScrollStyledRightShadow = styled.div<{ $visible: boolean }>`
  user-select: none;
  pointer-events: none;
  background: linear-gradient(
    270deg,
    ${({ theme }) => theme.colors.surface.pane} 0%,
    transparent 80%
  );
  bottom: 0;
  height: 100%;
  position: absolute;
  right: 0;
  top: 0;
  width: 100px;
  z-index: ${ZIndex.Shadow};
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transition: opacity 0.2s ease;
`;
